export const performanceVi = {
    performanceNew: {
        to: "Đến",
        AttendanceStatus: "Tình trạng chuyên cần",
        AttendanceTime: "Thời gian có mặt",
        Last7days: "Tuần gần nhất",
        quicklink: "quick link",
        OPlog: "OP log",
        precomplete: "pre-complete",
        inbound: "inbound",
        bound: "bound",
        APIcall: "API call",
        softphonecall: "softphone call"
    },
    relation: {
        companyPhone: "Điện thoại công ty",
        person2: "Người liên hệ 2",
        person3: "Người liên hệ 3",
        self: "Bản thân",
        role: "Vai trò",
        person1: "Người liên hệ 1",
        DispalyNum: "Số chủ",
        DestNum: "Số mục tiêu",
        BillID: "Mã đơn thoại",
        Direction: "Hướng cuộc gọi",
        IsnotConnect: "Có kết nối được không",
        OnboardTime: "Thời gian nhập chức",
        WaitingDuration: "Thời gian đợi máy quá lâu"
    },
    CallRecordQuery: {
        RecordingMethod: "Phương thức ghi chú",
        RecordingFile: "Tệp ghi âm",
        Supplier: "Nhà cung cấp"
    },
    RiskReport: {
        RiskReport: "Báo cáo rủi ro",
        Risk: "Rủi ro"
    },
    CommonParam: {
        ParameterName: "Tên tham số",
        ParameterDescription: "Mô tả tham số",
        OperatingTime: "Thời gian thao tác",
        Operator: "Người thao tác",
        ParameterValue: "Giá trị tham số"
    },
    salaryReport: {
        timelimit: "Phạm vi thời gian",
        whetherthenewstaffofthemonth: "Có phải nhân viên mới nhập chức trong tháng",
        basesalary: "Lương cơ bản",
        isthefirstofthestaffIDnumber5: "Mã số nhân viên bắt đầu từ 5?",
        basicdailywage: "Lương cơ bản mỗi tháng",
        actualbasicsalary: "Lương cơ bản thực tế",
        staffcreatetime: "Thời gian nhân viên tạo lập",
        CurrentCycle: "Chu kỳ hiện tại",
        LastCycle: "Chu kỳ trước",
        CurrentMonth: "Tháng này",
        Wagetimerange: "Thời hạn phát lương"
    },
    OrderStatus: {
        PartiallyCompleted: 'Parcialmente completada',
        beyondCompareSubmitFailed: 'Superar la cantidad deducible, la presentación falló',
    }
    //
    // "First login time today": "今天第一次登录时间",	"Hôm nay đăng ký lần đầu vào lúc"
    // "Last update time": "上次更新时间",	"Thời gian cập nhật lần trước"
    // 'Assign Num': "分配数",	"Số lượng phân bổ"
    // 'Group KPI repay amount': "小组目标回款金额",	"Mục tiêu hạn mức thanh toán nhóm"
    // 'KPI repay amount': "目标回款金额",	"Mục tiệu hạn mức thanh toán"
    // "login time": "登录时间",	"Thời gian đăng nhập"
    // "Half a month": "半月",	"Nửa tháng"
    // "That day": "当日",	"Trong ngày"
    // "Target amount of returns": "目标回款金额",	"Mục tiệu hạn mức thanh toán"
    // "Tiempo de PTP is incorrect, please fill in again": "承诺还款时间不正确，请重新填写",	"Thời gian hứa trả không chính xác, hãy nhập lại"
};
